export const ROLES = {
  COO: {
    label: 'COO',
    color: '#1F4E79',
    light: '#D5E8F0',
    icon: 'ti-crown',
    sections: [
      '0.1','0.2','0.3',
      '1.1','1.2','1.3',
      '2.1','2.2',
      '3.1','3.2','3.3','3.4',
      '4.1','4.2',
      '5.1','5.2','5.3',
      '6.1','6.2',
      '7.1','7.2','7.3',
      'X.1','X.2','X.3',
    ],
  },
  PM: {
    label: 'Project Manager',
    color: '#375623',
    light: '#E2EFDA',
    icon: 'ti-briefcase',
    sections: [
      '0.1','0.2','0.3',
      '1.1','1.2','1.3',
      '2.1','2.2',
      '3.1','3.4',
      '4.1','4.2',
      '5.1','5.2','5.3',
      '6.1','6.2',
      '7.1','7.2','7.3',
      'X.1','X.2','X.3',
    ],
  },
  FC: {
    label: 'Functional Consultant',
    color: '#7B3F00',
    light: '#FCE4D4',
    icon: 'ti-clipboard-list',
    sections: [
      '0.1',
      '1.1','1.2','1.3',
      '2.1','2.2',
      '3.1','3.3','3.4',
      '4.1','4.2',
      '5.1','5.2','5.3',
      '6.1',
      '7.2','7.3',
      'X.1','X.2','X.3',
    ],
  },
  DEV: {
    label: 'Developer',
    color: '#1B4F72',
    light: '#D6EAF8',
    icon: 'ti-code',
    sections: [
      '3.1','3.2','3.3','3.4',
      '4.1','4.2',
      '5.1','5.3',
      '7.3',
      'X.3',
    ],
  },
  DEVOPS: {
    label: 'DevOps Engineer',
    color: '#4A235A',
    light: '#EAD1DC',
    icon: 'ti-server',
    sections: [
      '3.2',
      '6.1','6.2',
      '7.3',
      'X.3',
    ],
  },
  TESTER: {
    label: 'Tester',
    color: '#922B21',
    light: '#FADBD8',
    icon: 'ti-test-pipe',
    sections: [
      '4.1','4.2',
      '5.1','5.2','5.3',
      '6.1',
      '7.3',
      'X.3',
    ],
  },
};

export const PHASES = [
  { code: 'P0', title: 'Project Initiation & Planning', keys: ['0.1','0.2','0.3'], icon: 'ti-rocket' },
  { code: 'P1', title: 'Requirements Gathering',        keys: ['1.1','1.2','1.3'], icon: 'ti-notes' },
  { code: 'P2', title: 'Solution Design',               keys: ['2.1','2.2'],       icon: 'ti-pencil-ruler' },
  { code: 'P3', title: 'Development',                   keys: ['3.1','3.2','3.3','3.4'], icon: 'ti-code' },
  { code: 'P4', title: 'Testing / QA',                  keys: ['4.1','4.2'],       icon: 'ti-bug' },
  { code: 'P5', title: 'User Acceptance Testing',       keys: ['5.1','5.2','5.3'], icon: 'ti-users' },
  { code: 'P6', title: 'Deployment',                    keys: ['6.1','6.2'],       icon: 'ti-rocket-off' },
  { code: 'P7', title: 'Project Closure & Handover',    keys: ['7.1','7.2','7.3'], icon: 'ti-flag-check' },
  { code: 'CX', title: 'Cross-Cutting (All Phases)',    keys: ['X.1','X.2','X.3'], icon: 'ti-repeat' },
];
